import MultiOperatorsList from './List/List';
import AppmultiOperatorsForm from './Form/Form';
import {
  MultiOperatorsDocumentHeaderColumn2,
  MultiOperatorsDocumentHeaderColumn3,
} from 'modules/app-views/_apps/appmulti/operators/Components';
import { getFromLocalStorage, parseDateToDisplay } from 'utils/helpers';
import {
  DefaultFormHeaderColumn1,
  DefaultFormHeaderCustomIcons,
} from 'components/jarvisly-module/Form/FormHeader';
import { API_ENTITIES } from 'constants/ApiConstant';

// GLOBAL VARIABLES ************************************************************
// *****************************************************************************

const MODULE_ID = 'appmultiOperators';

// MODULE PARAMETERS ***********************************************************
// *****************************************************************************

const MULTI_OPERATORS_MODULE = {
  id: MODULE_ID,
  noBlockScreenWithAppNotConfigured: false,
  api: API_ENTITIES,
  urlCustomForm: null,
  defaultUrlQueryString: null,

  components: {
    // list
    dashboard: null,
    list: props => <MultiOperatorsList {...props} />,
    grid: null,
    kanban: null,
    filter: null,

    // form
    form: (props, ref) => <AppmultiOperatorsForm {...props} ref={ref} />,
    formHeaderTitle: null,
    formHeaderSubtitle: null,
    formHeaderColumn1: props => <DefaultFormHeaderColumn1 {...props} />,
    formHeaderColumn2: props => (
      <MultiOperatorsDocumentHeaderColumn2 {...props} />
    ),
    formHeaderColumn3: props => (
      <MultiOperatorsDocumentHeaderColumn3 {...props} />
    ),
    formHeaderTags: null,
    formHeaderCustomIcons: props => (
      <DefaultFormHeaderCustomIcons
        {...props}
        showStatusIcon
        showApiIcon
        showApiIconOnlyConnected
      />
    ),

    // module Parameters
    parameters: null,

    // module data import
    dataImport: null,

    // data preview
    previewHeader: null,
    previewBody: null,
    previewActions: null,
  },

  methods: {
    decorateDocument,
    // canEditDocument
    // decorateParameters,
  },

  initialRequest: {
    folder: 'documents',
    folderOptions: ['documents', 'recycle', 'filed'],

/*
    filter: {
      dataProfile: ['contact'],
      dataType: ['person'],
    },
*/

    /*
        filter: {
          dataProfile: ['operator'],
          dataType: ['company'],
        },

        filterOptions: {
          dataProfile: ['operator'],
          dataType: ['company'],
          'Parameters.integrated': ['yes', 'no', 'whatever'],
          status: [
            // 'not_updated',
            // 'pending_update',
            // 'waiting_for_update',
            // 'updated',
            'in_analysis',
            'with_reservation',
            'revised',
          ],
        },
    */

    pagination: {
      pageNumber: 1, // current page
      pageSize: getFromLocalStorage('pageSize'),
    },

    paginationOptions: {
      pageSize: [10, 20, 50, 100],
    },

    /*
        sorter: {
          '_metadata.audit.updatedAt': -1,
        },
    
        sorterOptions: [
          '_metadata.documentStatus',
          'Parameters.__exchangeRate',
          '_integrations.operatorCode',
          'name',
          '_metadata.audit.updatedAt',
          '_metadata.counter',
          'status',
        ],
    
        search: {},
    
        textSearch: {},
    */
  },

  listState: {
    override: false,
    hideBreadcrumb: false,

    hideTitleSummary: false,
    hasFilter: true, // show the filter (folders and customs) drawer button
    hasNewOptionsButtons: true, // show options action button. p.s. if not exists 'new' action in documentState.actions, the new button will be hidden

    actions: [
      'refreshList',
      'clearSearch',
      'showLineNumbers'
    ],

    showParameters: false,
    showDataImport: false,

    initTab: null,
    viewMode: ['list'], // 'list', 'kanban', 'grid' or 'dashboard'
    showNumberOfLine: false, // show number of line in table list
    showCheckBoxes: false, // show check boxes on table list for multiple selection
    hasAccessControl: true, // show the control access modal for this module
    isTableChanged: false, // detect if the table was changed, check if the currentQs is different of initialQs (includes column sorter, search and pagination)
    isFilterChanged: false, // detect if the filters was changed
    fieldsForRegex: [],
    textSearchInDrawer: false, // inform that the textSearch field is into Drawer Filter to mark the filter button as danger (red)
    refreshDataOfList: 0,

    // filter options
    filterInitialize: {
      dataProfile: ['operator'],
      dataType: ['company'],
    },

    // sort options
    sorterInitialize: {
      '_metadata.audit.updatedAt': -1,
    },

    sorterOrderPrecedence: [
      '_metadata.counter',
      'name',
      'status',
      '_metadata.audit.updatedAt',
    ],
  },

  documentState: {
    showParameters: false,

    disableLockForEdit: false,
    initTab: 'record',
    fieldName: 'name',
    hasPicture: false,
    newDocumentTitle: 'new_operator',
    autoFill: false,
    actions: [
      'new',
      'edit',
      'reload',
      'divider',
      'duplicate',
      'file',
      'remove',
      'permanently_remove',
      'divider',
      'document_status',
    ],
    refreshParametersOnSave: true,
    indexes: [],

    refreshDataOfDocument: 0,
    mockDocument: {
      name: 'Infodesk',
      cnpj: '02934311000153',
      fullName: 'Infodesk Technologies Ltda',
      phone: '19982320000',
      email: 'biruel@infodesk.com.br',
      zip: '13070173',
      address1: 'Avenida Marechal Rondon',
      number: '700',
      address2: 'Sala 307',
      neighborhood: 'Jardim Chapadão',
      __city: 'Campinas - SP',
      parameters: { __exchangeRate: 5.21 },
    },
  },
};

// EXPORT ********************************************************************
// ***************************************************************************

export default MULTI_OPERATORS_MODULE;

// INTERNAL FUNCTIONS ========================================================
// ===========================================================================

function decorateDocument(doc) {
  if (doc?.parameters?.__currency === 'brl') {
    doc.parameters.__hideExchangeOnList = true;
  }

  // decorate date fields
  doc?.moreContacts?.map(
    c => (c.birthdate = c.birthdate && parseDateToDisplay(c.birthdate)),
  );

  return doc;
}
